'use client';
import { useField, Field } from 'formik';

import { classNames } from '@repo/ui/src/utils/classNames';
import React, { TextareaHTMLAttributes } from 'react';

export interface InputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  name: string;
  className?: string;
  inputStyles?: string;
}

// eslint-disable-next-line react/display-name
const TextArea = React.forwardRef(
  ({ label, className, inputStyles, ...props }: InputProps, ref) => {
    const [field, meta] = useField(props);

    return (
      <div className={classNames('tw-w-full', className)}>
        <label className="tw-w-full tw-flex tw-flex-col	tra-text-web-body-s">
          {label && (
            <span className="tra-text-web-heading-7 tw-mb-6 dark:tw-text-warm-100">{label}</span>
          )}
        </label>
        <Field
          innerRef={ref}
          as="textarea"
          className={classNames(
            'tra-input-text',
            'tra-text-web-body-m tw-h-[180px] tw-py-5 tw-px-4 tw-resize-none tw-border-neutral-500 tw-w-full',
            meta.touched && meta.error && 'tw-border-red-400',
            inputStyles,
          )}
          {...field}
          {...props}
        />
        {meta.touched && meta.error ? (
          <span className="tra-input-error" data-testid="input-error">
            {meta.error}
          </span>
        ) : null}
      </div>
    );
  },
);

export default TextArea;
